import { activeOrgSelector } from 'redux/reducer/AuthenticationReducer';
import { axiosInstance } from 'utils/http';
import { liveCleanroom } from 'utils/urlConstants';
import { showAlert } from 'redux/actions/AlertActions';
import { useDispatch, useSelector } from 'react-redux';
import { useQuery } from 'react-query';


export const useGetWarehouse = (lcrId, warehouseId) => {
  const { ID: orgId } = useSelector(activeOrgSelector);
  const dispatch = useDispatch();

  return useQuery(
    ['warehouse', lcrId, warehouseId],
    () => axiosInstance.get(liveCleanroom(orgId).getWarehouse(lcrId, warehouseId)),
    {
      enabled: !!warehouseId,
      select: (response) => response.data?.liveCleanRoomWarehouse,
      onError: (error) => {
        dispatch(
          showAlert({
            message: error.response?.data?.message || 'Error fetching warehouse details',
            type: 'error',
          }),
        );
      },
    },
  );
};
